<div class="modal-overlay" *ngIf="isVisible">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-content">
      <div class="alert-icon">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M32 4L4 56H60L32 4Z" fill="#E30613" stroke="#E30613" stroke-width="2"/>
          <path d="M32 20V36M32 44V46" stroke="white" stroke-width="3" stroke-linecap="round"/>
        </svg>
      </div>

      <h2 class="modal-title">{{ title }}</h2>
      <p class="modal-message">{{ message }}</p>

      <div class="modal-actions">
        <button
          class="btn btn-primary"
          (click)="onChangePassword()"
          type="button">
          Cambiar contraseña
        </button>

        <button
          *ngIf="!isExpired"
          class="btn btn-secondary"
          (click)="onSkip()"
          type="button">
          Omitir
        </button>
      </div>
    </div>
  </div>
</div>
